import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Document, Issue } from '../core/types';
import DocumentModal from './DocumentModal';

interface Props {
  documents: Document[];
  issues: Issue[];
}

const docIcon = (type: Document['type']): string => {
  if (type === 'passport') return '🛂';
  if (type === 'statement') return '📝';
  return '📎';
};

const DocumentsSection: React.FC<Props> = ({ documents, issues }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<Document | null>(null);

  return (
    <>
      <div className="documents-section">
        <h2>{t('documents.title')}</h2>
        <div className="documents-grid">
          {documents.map((doc, index) => (
            <div key={index} className="document-card" onClick={() => setSelected(doc)}>
              <h3>
                <span className="document-icon">{docIcon(doc.type)}</span>
                {doc.title}
              </h3>
              <div className="document-content">
                {Object.entries(doc.content).map(([key, value]) => (
                  <div key={key}>
                    <strong>{key}:</strong> {value}
                  </div>
                ))}
              </div>
              <div className="doc-card-hint">{t('documents.clickToInspect')}</div>
            </div>
          ))}
        </div>
      </div>

      {selected && (
        <DocumentModal
          document={selected}
          issues={issues}
          onClose={() => setSelected(null)}
        />
      )}
    </>
  );
};

export default DocumentsSection;
